site:
  title: Affiliates system
  lang: en
modals:
  login:
    title: Log in
    submitButton: Log in
    resetLink: Reset you password
    signUpLink: Register
    or: or
  reset:
    title: Forgot your password?
    submitButton: Reset Password
  signUp:
    title: Register
    submitButton: Register
    termsText: I accept the
    termsLink: Affiliate Terms & Conditions
  notVerified:
    title: You have registered successfully.
    text: We will review your application and, if your account is verified, you will be notified via email.
  terms:
    title: AFFILIATE TERMS & CONDITIONS
whyUs:
  title: Why us?
  subtitle: With up to 45% Revenue Share deal on offer, it's time to start profitable cooperation!
  note: ''
  action:
    text: ''
  modifier: card--primary
  list:
    - id: whyus-1
      title: 24/7 Support
      text: Unlike most of the competition, our managers are eager to help you boost performance. No question is considered trivial. Got an idea? Tell us through whichever communication channel you prefer.
      image: support
    - id: whyus-2
      title: Top Game Lobbies
      text: We pride ourselves on the quality and quantity of games within our game lobbies for your player. We have something for everyone. Over 9,500+ titles and counting!
      image: game
    - id: whyus-3
      title: Detailed Stats
      text: 'Our unique affiliate system provides you hourly updates as well as allowing you to track your campaigns, customers and traffic"'
      image: stats
    - id: whyus-4
      title: Fast Affiliate Payments
      text: We pay our affiliates fast. At the start of each month, we pay commissions within 5 business days.
      image: wallet
    - id: whyus-5
      title: Lifetime Revenue
      text: As always us your potential revenue is limitless, the more traffic you bring in, the more you will earn. Our generous payout structure allows you to earn on every player.
      image: revenue
    - id: whyus-6
      title: 35+ Countries
      text: Support for customers and affiliates in 11 different languages, customers from over 35 countries.
      image: countries
commission:
  title: Commission
  subtitle: Our commission packages are well-balanced for both new and veteran affiliate partners. We offer a revenue share plan that pays out a percentage of the Net Revenue of the referred players monthly! Our tiered plans start at 20% and rise up to 50% by simply promoting our top converting casino brands.
  note: '*We create custom reward plans including CPA, Hybrid deals, and more. Get in touch with us for more details. See how we can offer a bespoke plan that fits your traffic needs.'
  action:
    text: Become Our Partner
    modal: signup
    variant: button
    buttonVariant: primary
  button: Get Started
  variant: circular
  modifier: card--primary
  list:
    - title: of revenue share
      image: countries
      list:
        - '1'

      level: 1ST LEVEL
      percentage: 20
      range: 0 - 4 NDC
      id: 1763469684552_mb4d4cc4g
    - title: of revenue share
      image: stats
      list:
        - ''
      level: 2ND LEVEL
      percentage: 30
      range: 5 - 19 NDC
      id: 1763469684552_f6c4s5pc2
    - title: of revenue share
      image: wallet
      list:
        - ''
      level: 3RD LEVEL
      percentage: 40
      range: 15 - 39 NDC
      id: 1763469684552_mo2jxuc70
    - title: of revenue share
      image: revenue
      list:
        - ''
      level: 4TH LEVEL
      percentage: 45
      range: 40 - 59 NDC
      id: 1763469684552_odsrduhmx
    - title: of revenue share
      image: wallet
      list: []
      level: 5TH LEVEL
      percentage: 50
      range: 60+
      id: 1763469684552_lst9i1xuq
testimonials:
  title: Testimonials
  subtitle: ''
  note: ''
  action:
    text: ''
  list:
    - id: testimonial-1
      text: We are really looking forward working with SuperPartners. Their product is one of the best for the Scandinavian market, and we are really looking forward to see the longterm performance. We can truly recommend working with them.
      link:
        text: uudet-pikakasinot-fi.com
        href: uudet-pikakasinot-fi.com
    - id: testimonial-2
      text: If you're looking for a highly profitable online casino affiliate program, the answer is "Super Casino". This can only be achieved with a simple, clear affiliate program and a compelling site. "Oncasitown" is pleased to be able to promote this attractive site in the Japanese market.
      link:
        text: oncasitown.com
        href: oncasitown.com
    - id: testimonial-3
      text: It is not an easy task to find a trustworthy and high-performing online casino that keeps players satisfied, but we at AskGamblers can honestly say that Super Casino is one of them. Super Casino brand is quite popular among players, we can see great results coming from them, and it’s a win-win situation all around.
      link:
        text: www.askgamblers.com
        href: www.askgamblers.com
    - id: testimonial-4
      text: Working with Super Partners has proven to be a smart decision. Payments are always on time, the deals are competitive, and the support team is both proactive and reliable. A truly professional partnership that adds real value.
      link:
        text: Laura T.D
faq:
  title: FAQ
  subtitle: ''
  note: ''
  action:
    text: Affiliate Program Terms & Conditions
    modal: terms
  list:
    - id: section-1
      question: What is SuperPartners?
      answer: SuperPartners is a casino affiliate program which has great experience in the gambling market. Promote our top-earning online casino brands and take home the big bucks.  We guarantee reliability, stability, and dedicated support!
      type: text
    - id: section-2
      question: When will I get paid?
      answer: We provide fast and reliable payouts on a regular schedule. No delays, no hidden fees.
      type: text
    - id: section-3
      question: What commission models do you offer?
      answer: You can choose from Revenue Share, CPA, Hybrid deals, or request custom conditions based on your traffic.
      type: text
    - id: section-4
      question: Which GEOs do you work with?
      answer: Right now, our focus is on Tier-1 markets, but we're constantly expanding to new regions.
      type: text
    - id: section-5
      question: Do you provide marketing materials?
      answer: Yes. We offer banners, landing pages, tracking links, and other creative assets to help you maximize conversions.
      type: text
    - id: section-6
      question: Who do I contact if I need help?
      answer: Your dedicated affiliate manager is always available to answer questions and provide support.
      type: text
contacts:
  title: Contacts
  subtitle: ''
  note: ''
  action:
    text: ''
  list:
    - id: contact-1
      type: email
      href: '#'
      text: contact@super.partners
      icon: message
      alt: Email icon
    - id: contact-2
      type: telegram
      href: '#'
      text: super_partners
      icon: telegram
      alt: super_partners icon
    - id: contact-3
      type: social
      href: '#'
      text: super_partners
      icon: instagram
      alt: super_partners icon
hero:
  title: Global Affiliate Program
  subtitle: Join our
  text: SuperPartners is a casino affiliate program which has great experience in the gambling market. Promote our top-earning online casino brands and take home the big bucks.  We guarantee reliability, stability, and dedicated support!
  action:
    text: Join now
    modal: signup
    variant: button
  image: banner
  imageMobile: banner-mob
footer:
  copyright: © 2026 Super Partners | All rights reserved
settings:
  showMenu: true
  showHero: true
  showWhyUs: true
  showCommission: true
  showTestimonials: true
  showFaq: true
  showContacts: true
metadata:
  title: Affiliates system
  description: Affiliates system
  keywords: casino affiliate, affiliate program, revenue share, CPA, hybrid deals, gambling affiliate
  author: SuperPartners
  robots: index, follow
